import type { IconData } from '@stacksjs/iconify-core'

export const entertainmentEventsHobbiesChessPawn: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.905 26.66h1.52v3.05h-1.52Zm-19.81 3.05h19.81v1.53H6.095Zm15.24-9.14h1.52v1.52h-1.52Zm0-9.14h1.52v1.52h-1.52Zm-1.53 7.62h1.53v1.52h-1.53Zm-6.09 0v-4.58h4.57v4.58h1.52v-4.58h1.53v-1.52h-10.67v1.52h1.53v4.58zm7.62-7.62V9.9h-1.53V8.38h1.53V3.81h-1.53V2.28h-1.52V.76h-4.57v1.52H12.2v1.53h-1.53v4.57h1.53V9.9h-1.53v1.53Zm-6.1-7.62h1.53v1.52h1.52v1.53h-1.52V5.33h-1.53Zm-4.57 15.24h1.53v1.52h-1.53Zm-1.52 1.52h1.52v1.52h-1.52Zm0-9.14h1.52v1.52h-1.52Zm0 13.71v-3.05h-1.53v3.05h-1.52v1.52h19.81v-1.52h-1.52v-3.05h-1.53v3.05zm-4.57 1.52h1.52v3.05h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default entertainmentEventsHobbiesChessPawn
